import { useQuery } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

import type { IProjectTimelineEvent } from "../../interfaces";

export default function useProjectTimeline() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useListEvents(projectId: string, options?: { category?: string; limit?: number }) {
        return useQuery({
            queryKey: ["project-timeline", projectId, options?.category, options?.limit],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/project-timeline/list", {
                    params: {
                        ProjectId: projectId,
                        ...(options?.category ? { Category: options.category } : {}),
                        Limit: options?.limit ?? 50,
                    },
                });
                return parseSuccessResponseData(response) as IProjectTimelineEvent[];
            },
            enabled: !!projectId,
        });
    }

    return { useListEvents };
}
